// import React from 'react';
// import 'antd/dist/antd.css';  // 引入Ant Design样式
// import FeishuLogin from './FeishuLogin';

// function App() {
//   return (
//     <div className="App">
//       <FeishuLogin />
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'antd/dist/antd.css';
import FeishuLogin from './FeishuLogin';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* 默认首页可以重定向到二维码登录页 */}
          <Route path="/" element={<Navigate to="/qrLogin" replace />} />
          
          {/* 二维码登录页 */}
          <Route path="/qrLogin" element={<FeishuLogin />} />
          
          {/* 可以添加其他页面 */}
          <Route path="/home" element={<div>首页</div>} />
          
          {/* 404页面 */}
          <Route path="*" element={<div>页面不存在</div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;